import Vue from 'vue';
import Vuetify from 'vuetify';
// import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
  theme: {
    // primary: '#008EC8',
    primary: '#2196F3',
    // primary: '#6666FF',
    secondary: '#0288D1',
    // accent: "#FBC02D",
    accent: '#333333',
    error: '#f44336',
    warning: '#FFEB3B',
    info: '#00B8D4',
    success: '#00C853',
  },

  /*
{
  primary: "#1976D2",
  secondary: "#FFAB40",
  accent: "#E65100",
  error: "#f44336",
  warning: "#FDD835",
  info: "#03A9F4",
  success: "#00C853"
} */


});
